import { createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react';
import { jwtDecode } from "jwt-decode";
import { Route, Routes, useNavigate } from 'react-router-dom';

import { Buy } from './pages/Buy';
import { Home } from './pages/Home';
import Profile from './pages/Profile';
import Android from './pages/instructions/Android';
import Ios from './pages/instructions/Ios';
import Windows from './pages/instructions/Windows';
import Macos from './pages/instructions/Macos';
import Tv from './pages/instructions/Tv';
import Linux from './pages/instructions/Linux';
import Login from './components/Login';

import s from './styles/App.module.css';
import tg from './assets/photo/tg.png';
import mail from './assets/photo/почта.png';
import max from './assets/photo/MAX.webp';

interface TokenContextType { 
  token: string | null;
  setToken: Dispatch<SetStateAction<string | null>>;
}

interface AuthContextType {
  auth: boolean;
  setAuth: Dispatch<SetStateAction<boolean>>;
}

interface FreeTrialContextType {
  trial: boolean;
  setTrial: Dispatch<SetStateAction<boolean>>;
}

interface DatasContextType {
  datas: Record<string, unknown>;
  setDatas: Dispatch<SetStateAction<Record<string, unknown>>>;
}

interface AuthButtonContextType {
  authBut: boolean | ReactNode;
  setAuthBut: Dispatch<SetStateAction<boolean | ReactNode>>;
}

interface CurrentMonthContextType {
  currentMonth: number;
  setCurrentMonth: Dispatch<SetStateAction<number>>;
}

interface CustomJwtPayload {
  username?: string;
  [key: string]: unknown;
}

export const TokenContext = createContext<TokenContextType | null>(null);
export const Authorization = createContext<AuthContextType | null>(null);
export const FreeTrial = createContext<FreeTrialContextType | null>(null);
export const Datas = createContext<DatasContextType | null>(null);
export const AuthButton = createContext<AuthButtonContextType | null>(null);
export const CurrentMonth = createContext<CurrentMonthContextType | null>(null);

function App() {
  const [token, setToken] = useState<string | null>(null);
  const [auth, setAuth] = useState<boolean>(false);
  const [jwtData, setJwtData] = useState<string>('');
  const [trial, setTrial] = useState<boolean>(false);
  const [datas, setDatas] = useState<Record<string, unknown>>({});
  const [authBut, setAuthBut] = useState<boolean | ReactNode>(false);
  const [currentMonth, setCurrentMonth] = useState<number>(0);

  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');

  if (ref) {
    window.localStorage.setItem('ref', ref);
  }
  
  const navigate = useNavigate();

  useEffect(() => {
    refresh();
  }, []);

  async function refresh() {
    try {
      const res = await fetch('https://libervpn.ru/api/refresh', {
      // const res = await fetch('http://localhost:5000/refresh', {
        method: 'POST',
        credentials: 'include'
      });
      const data = await res.json();

      if (data && data['access'] === true) {
        const accessToken = data['access_token'];
        setToken(accessToken);
        
        const decoded = jwtDecode<CustomJwtPayload>(accessToken);
        if (decoded.username) {
          setJwtData(decoded.username);
        }
        
        setDatas(decoded as Record<string, unknown>);
        setAuth(true);
      }
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <>
      <Authorization value={{ auth, setAuth }}>
        <TokenContext value={{ token, setToken }}>
          <FreeTrial value={{ trial, setTrial }}>
            <Datas value={{ datas, setDatas }}>
              <AuthButton value={{ authBut, setAuthBut }}>
                <CurrentMonth value={{ currentMonth, setCurrentMonth }}>
                  {authBut && <Login />}
                  <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/buy' element={<Buy />} />
                    <Route path='/profile' element={<Profile />} />
                    <Route path='/android' element={<Android />} />
                    <Route path='/ios' element={<Ios />} />
                    <Route path='/windows' element={<Windows />} />
                    <Route path='/macos' element={<Macos />} />
                    <Route path='/linux' element={<Linux />} />
                    <Route path='/tv' element={<Tv />} />
                  </Routes>
                </CurrentMonth>
              </AuthButton>
            </Datas>
          </FreeTrial>
        </TokenContext>
      </Authorization>

      <footer className={s.footer}>
        <div className={s.footer_content}>
          <div className={s.footer_brand}>
            <p className={s.footer_slogan}>
              Твой надёжный инструмент для свободного и безопасного интернета. Работаем для вашей безопасности каждый день.
            </p>
          </div>

          <div className={s.footer_col}>
            <p className={s.footer_col_title}>Документация</p>
            <a href="./Политика возврата.pdf" className={s.footer_link}>Политика возврата</a>
            <a href="./Политика конфиденциальности.pdf" className={s.footer_link}>Политика конфиденциальности</a>
            <a href="./Реквизиты.pdf" className={s.footer_link}>Реквизиты</a>
            <a href="./Правила реферальной программы.pdf" className={s.footer_link}>Реферальная программа</a>
          </div>

          <div className={s.footer_col}>
            <p className={s.footer_col_title}>Инструкция</p>
            <a className={s.footer_link} onClick={() => navigate('/android')}>Android</a>
            <a className={s.footer_link} onClick={() => navigate('/ios')}>IOS</a>
            <a className={s.footer_link} onClick={() => navigate('/linux')}>Linux</a>
            <a className={s.footer_link} onClick={() => navigate('/macos')}>MacOS</a>
          </div>

          <div className={s.footer_col}>
            <p className={s.footer_col_title}>Контакты</p>
            <a href="https://t.me/libervpn_support" className={s.footer_link}><img src={tg} alt="Telegram" /> Libervpn_support</a>
            <a href="mailto:support@libervpn.ru" className={s.footer_link}><img src={mail} alt="Email" /> support@libervpn.ru</a>
            <a href="https://max.ru/u/f9LHodD0cOJHZmyal51WgzhxKuKsCCeatobbdzLwowoWFu-SYi2yUOHCaWE" className={s.footer_link}>
              <img src={max} alt="MAX" /> Мы в MAX
            </a>
          </div>
        </div>

        <div className={s.footer_bottom}>
          <span>© 2026 Liber VPN. Все права защищены.</span>
        </div>
      </footer>
    </>
  );
}

export default App;